/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-03-11 16:11:07
 *
 *******************************************************/
// @flow

import React from 'react';
export function ProfileIcon(props) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0C15.5138 0 20 4.48625 20 10C20 15.5138 15.5138 20 10 20C4.48625 20 0 15.5138 0 10C0 4.48625 4.48625 0 10 0ZM16.2406 15.0001C14.7731 16.8279 12.5208 18 10 18C7.47915 18 5.22676 16.8278 3.75931 14.9999C5.22677 13.1721 7.4791 12 9.99988 12C12.5207 12 14.7731 13.1722 16.2406 15.0001ZM10 10C11.6569 10 13 8.65685 13 7C13 5.34315 11.6569 4 10 4C8.34315 4 7 5.34315 7 7C7 8.65685 8.34315 10 10 10Z"
      />
    </svg>
  );
}

export function ProfileMinorIcon(props) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.0001 11.9996C6.6953 11.9996 5.5489 11.366 4.8177 10.3996C5.5489 9.43321 6.6953 8.79961 8.0001 8.79961C9.3049 8.79961 10.4513 9.43321 11.1825 10.3996C10.4513 11.366 9.3049 11.9996 8.0001 11.9996ZM8.0001 3.99961C8.8833 3.99961 9.6001 4.71721 9.6001 5.59961C9.6001 6.48201 8.8833 7.19961 8.0001 7.19961C7.1169 7.19961 6.4001 6.48201 6.4001 5.59961C6.4001 4.71721 7.1169 3.99961 8.0001 3.99961ZM8.0001 1.59961C4.4713 1.59961 1.6001 4.47081 1.6001 7.99961C1.6001 11.5284 4.4713 14.3996 8.0001 14.3996C11.5289 14.3996 14.4001 11.5284 14.4001 7.99961C14.4001 4.47081 11.5289 1.59961 8.0001 1.59961Z"
        fill="#8C9196"
      />
    </svg>
  );
}
